import React from "react"
import { useTranslation } from "react-i18next"

import { useApiContext } from "~/api"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"
import { SubscriptionMagazinePress } from "~/components/SubscriptionMagazinePress/SubscriptionMagazinePress"

import { SubscriptionMagazine } from "../SubscriptionMagazine/SubscriptionMagazine"
import { CardWrapper } from "./components/CardWrapper/CardWrapper"
import { FormWrapper } from "./components/FormWrapper/FormWrapper"
import styles from "./index.module.css"

type Props = {
  title?: string
  content?: () => JSX.Element
  showMobileText?: boolean
  codeSubscription?: string
  titleSubscriptionMagazine?: string
  inCareer?: boolean
  excludeValidate?: string[]
  codeSubscriptionPress?: boolean
}

export const ContactForm: React.FC<Props> = ({
  title,
  content,
  showMobileText,
  codeSubscription,
  titleSubscriptionMagazine,
  inCareer,
  excludeValidate,
  codeSubscriptionPress,
}) => {
  const { t } = useTranslation()
  const { contacts } = useApiContext("/formwithcontacts/list")

  return (
    <div className={styles.Wrapper} id="footer-form">
      <div className="container">
        {title && (
          <Heading as="h2" className={styles.Title} like="h1">
            <Raw html={title} />
          </Heading>
        )}

        <div className={styles.Inner}>
          {content && content()}

          <div>
            {showMobileText && (
              <div className={styles.MobileText}>
                <Raw html={t("blueForm.Form.MobileText")} />
              </div>
            )}

            <FormWrapper excludeValidate={excludeValidate} />
          </div>

          {contacts && (
            <div className={styles.CardsWrapper}>
              <div className={styles.Cards}>
                {/* hidden first two elements by task #5 */}
                {contacts.map((contact) => (
                  <CardWrapper key={contact.id} {...contact} />
                ))}
              </div>
            </div>
          )}

          {codeSubscription && (
            <div>
              <SubscriptionMagazine
                code={codeSubscription}
                inCareer={inCareer}
                title={titleSubscriptionMagazine}
                inContactForm
              />
            </div>
          )}

          {codeSubscriptionPress && (
            <div className={styles.SubscriptionPress}>
              <SubscriptionMagazinePress />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
